import axios from "axios";

// Shared axios instance for the copper-api proxy. Every request gets the
// `x-api-key` header so the backend can reject anything that isn't us.
// Base URL + key come from env so dev/stage/prod can each have their own.

const COPPER_BASE = process.env.REACT_APP_COPPER_API || "http://localhost:3003";
const COPPER_KEY = process.env.REACT_APP_COPPER_API_KEY || "";

const copperApi = axios.create({
  baseURL: COPPER_BASE,
});

// Inject the key on every request via an interceptor rather than relying on
// `axios.create({ headers })` defaults, which can be silently clobbered when
// callers pass their own `headers` config. The interceptor stamps the header
// last so it is always present.
copperApi.interceptors.request.use((config) => {
  if (COPPER_KEY) {
    config.headers = { ...(config.headers || {}), "x-api-key": COPPER_KEY };
  }
  return config;
});

if (!COPPER_KEY && typeof window !== "undefined") {
  // Loud warning so the dev console points at the real cause when the
  // backend is gated and the build was done without the env var set.
  // CRA only reads .env at `npm start` — restarting the dev server is
  // required after changing REACT_APP_COPPER_API_KEY.
  // eslint-disable-next-line no-console
  console.warn(
    "[copper-api] REACT_APP_COPPER_API_KEY is empty. Requests will be sent without `x-api-key` and the proxy will return 401. Set it in Client-Admin/frontend/.env and restart `npm start`."
  );
}

export { copperApi, COPPER_BASE };
export default copperApi;
